import {InPageAlert} from '@snsw-gel/react';
import React from 'react';

/**
 * Alert box to give info that a personal/business cannot be linked
 * when a mixed is already linked.
 */
const CannotLinkPersonalOrBusinessAlert: React.JSX.Element = (
    <InPageAlert
        variant='info'
        title={'A personal (mixed) toll account is already linked'}
        id='personalMixedAlreadyLinked'
    >
        <p>
            To link this type of toll account you'll need to remove the linked 'mixed' personal toll account.
            You can only claim a personal or business rebate on one toll account.
        </p>
    </InPageAlert>
);

export default CannotLinkPersonalOrBusinessAlert;
